import React, { useState, useEffect } from "react";
import {
  Grid,
  List,
  Card,
  CardHeader,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
  Divider,
  Typography,
  Avatar,
  ListItemAvatar,
  Box,
  Link,
  IconButton,
  Paper,
} from "@common-ui/ui";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";
import { AssetImage } from "../../pages/Assets/AseetImage";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const DataList = ({
  data,
  workEventID,
  workItems,
  setWorkItems,
  setUpdatedLeft,
  allAsset,
}) => {
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState(data || []);

  useEffect(() => {
    setUpdatedLeft(left);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left]);
  // const [workItems, setWorkItems] = React.useState([]);

  const leftChecked = intersection(checked, left);
  // const workItemsChecked = intersection(checked, workItems);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setWorkItems(workItems.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = (value) => {
    // console.log("check left", value);
    setLeft(left.concat([value]));
    setWorkItems(not(workItems, [value]));
    setChecked(not(checked, [value]));
  };

  const customListLeft = (title, items) => (
    <Paper elevation={4}>
      <Card>
        <CardHeader
          sx={{ px: 2, py: 1 }}
          avatar={
            <Checkbox
              onClick={handleToggleAll(items)}
              checked={
                numberOfChecked(items) === items.length && items.length !== 0
              }
              indeterminate={
                numberOfChecked(items) !== items.length &&
                numberOfChecked(items) !== 0
              }
              disabled={items.length === 0}
              inputProps={{
                "aria-label": "all items selected",
              }}
            />
          }
          title={<Typography fontWeight={700}>{title}</Typography>}
          subheader={
            <Typography>{`${numberOfChecked(items)}/${
              items.length
            } selected`}</Typography>
          }
        />
        <Divider />
        <List
          sx={{
            width: 350,
            height: 350,
            bgcolor: "background.paper",
            overflow: "auto",
          }}
          dense
          component="div"
          role="list"
        >
          {allAsset.length ? (
            items?.length ? (
              items.map((value) => {
                const labelId = `transfer-list-all-item-${value}-label`;
                let found = undefined;
                found = checked.find(
                  (item) => item.system_id === value.system_id
                );
                return (
                  <ListItem
                    key={value?.system_id}
                    role="listitem"
                    button
                    onClick={handleToggle(value)}
                    selected={found ? true : false}
                  >
                    <ListItemIcon>
                      <Checkbox
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemAvatar>
                      <AssetImage asset={value} />
                    </ListItemAvatar>
                    <ListItemText
                      id={labelId}
                      primary={
                        <Typography
                          variant="body1"
                          color="text.primary"
                          noWrap
                          // sx={{ fontWeight: "inherit", flexGrow: 1 }}
                        >
                          {value.name}
                        </Typography>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            color="text.secondary"
                            noWrap
                          >
                            {value.model}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                );
              })
            ) : (
              <Typography variant="body2" textAlign="center">
                All work items have been selected.
              </Typography>
            )
          ) : (
            <Typography variant="body2" textAlign="center">
              This client does not own an asset.
            </Typography>
          )}
          <ListItem />
        </List>
      </Card>
    </Paper>
  );

  const customListRight = (title, items) => (
    <Paper elevation={4}>
      <Card>
        <CardHeader
          sx={{ px: 2, py: 1 }}
          title={<Typography fontWeight={700}>{title}</Typography>}
          subheader={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={items.length ? { color: "success.main" } : {}}
              >{`${items.length} item${
                items.length > 1 ? "s" : ""
              } in list`}</Typography>
              <Typography align="inherit">
                <Link
                  sx={{ my: 1 }}
                  component="button"
                  onClick={() => {
                    // console.log("allAsset", allAsset);
                    setLeft(allAsset);
                    setWorkItems([]);
                  }}
                >
                  Clear all
                </Link>
              </Typography>
            </Box>
          }
        />
        <Divider />
        <List
          sx={{
            width: 350,
            height: 350,
            bgcolor: "background.paper",
            overflow: "auto",
          }}
          dense
          component="div"
          role="list"
        >
          {items?.length ? (
            items.map((value) => {
              const labelId = `transfer-list-all-item-${value}-label`;
              return (
                <ListItem
                  key={value?.system_id}
                  role="listitem"
                  button
                  // onClick={handleToggle(value)}
                  secondaryAction={
                    value?.workItemID ? (
                      ""
                    ) : (
                      <IconButton
                        aria-label="remove"
                        edge="end"
                        onClick={() => {
                          handleCheckedLeft(value);
                        }}
                        sx={{
                          // position: "absolute",
                          // workItems: 8,
                          // top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <Close />
                      </IconButton>
                    )
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                      variant="rounded"
                      alt={value.model}
                      src={`https://avatars.dicebear.com/v2/initials/${value.name}.svg?chars=2`}
                    />
                  </ListItemAvatar>

                  <ListItemText
                    id={labelId}
                    primary={
                      <Typography
                        // sx={{ display: "inline" }}
                        // component="span"
                        variant="body1"
                        color="text.primary"
                        noWrap
                      >
                        {value.name}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          // sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          noWrap
                          color="text.secondary"
                        >
                          {value.model}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
              );
            })
          ) : (
            <Typography variant="body2" textAlign="center">
              No work item selected.
            </Typography>
          )}
          <ListItem />
        </List>
      </Card>
    </Paper>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>{customListLeft("All Work Items", left)}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected workItems"
          >
            &gt;
          </Button>
          {/* <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={workItemsChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button> */}
        </Grid>
      </Grid>
      <Grid item>
        {customListRight(`Work Event ${workEventID}`, workItems)}
      </Grid>
    </Grid>
  );
};

DataList.propType = {
  data: PropTypes.array,
};

DataList.defaultProps = {};
export { DataList };
